import plays from './insights/plays'
import ratings from './insights/ratings'
import collection from './insights/collection'
import members from './insights/members'
import records from './insights/records'
import opponents from './insights/opponents'
import shelf from './insights/shelf'
import worth from './insights/worth'
import size from './insights/size'
import hindex from './insights/hindex'
import players from './insights/players'
import player from './insights/player'
import game from './insights/game'
import games from './insights/games'

export default {

	namespaced: true,

	modules: {
		plays: plays,
		ratings: ratings,
		collection: collection,
		members: members,
		records: records,
		opponents: opponents,
		shelf: shelf,
		worth: worth,
		size: size,
		hindex: hindex,
		players: players,
		player: player,
		game: game,
		games: games
	},

	state: {},

	getters: {

		hindex: function(state, getters) {

			return getters['hindex/all']

		},

		players: function(state, getters) {

			return getters['players/all']

		},

		player: function(state, getters) {

			return getters['player/all']

		},

		game: function(state, getters) {

			return getters['game/all']

		},

		games: function(state, getters) {

			return getters['games/all']

		},

		shelf: function(state, getters) {

			return getters['shelf/all']

		},

		size: function(state, getters) {

			return getters['size/all']

		},

		worth: function(state, getters) {

			return getters['worth/all']

		},

		plays: function(state, getters) {

			return getters['plays/all']

		},

		ratings: function(state, getters) {

			return getters['ratings/all']

		},

		collection: function(state, getters) {

			return getters['collection/all']

		},

		members: function(state, getters) {

			return getters['members/all']

		},

		records: function(state, getters) {

			return getters['records/all']

		},

		opponents: function(state, getters) {

			return getters['opponents/all']

		}

	},

	mutations: {},

	actions: {}

}